<template>
  <div class="header">
    <div class="header-content">
      <div class="logo">
        <img src="@/assets/logo.png" alt="" />
      </div>
      <div class="nav-menu">
        <ul class="nav-list">
          <li
            class="nav-item"
            v-for="item in menuList"
            @click="handleClick(item)"
            :key="item.name"
            :class="{ active: isActive(item) }"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeMenuItem: {
        title: "首页",
        path: "/home",
        name: "home",
      },
      menuList: [
        {
          title: "首页",
          path: "/home",
          name: "home",
        },
        {
          title: "公司产品",
          path: "/product",
          name: "product",
        },
        {
          title: "解决方案",
          path: "/solution",
          name: "solution",
        },
        {
          title: "服务案例",
          path: "/service-case",
          name: "service-case",
        },
        {
          title: "新闻动态",
          path: "/news",
          name: "news",
        },
        {
          title: "招聘信息",
          path: "/job-info",
          name: "job-info",
        },
        {
          title: "联系我们",
          path: "/contact-us",
          name: "contact-us",
        },
      ],
    };
  },

  methods: {
    handleClick(item) {
      this.$router
        .push({
          path: item.path,
        })
        .then(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        });
    },
    isActive(item) {
      const currentPath =
        this.$route && this.$route.path ? this.$route.path : "";
      return (
        currentPath === item.path ||
        (item.path !== "/" && currentPath.indexOf(item.path + "/") === 0)
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        const found = this.menuList.find(
          (m) =>
            to.path === m.path ||
            (m.path !== "/" && to.path.indexOf(m.path + "/") === 0)
        );
        if (found) {
          this.activeMenuItem = found;
        } else {
          // 若找不到匹配，且在首页层级，默认高亮首页
          const homeItem = this.menuList.find((m) => m.path === "/home");
          this.activeMenuItem = homeItem || this.menuList[0];
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  backdrop-filter: blur(30px); /* 背景模糊30px */
  -webkit-backdrop-filter: blur(30px); /* Safari浏览器兼容性 */
  position: fixed; /* 固定定位 */
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* 确保在其他元素之上 */
  width: 100%;
  height: 80px; /* 根据设计稿设置高度 */
  border-radius: 0px 0px 0px 0px; /* 根据设计稿设置圆角 */

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 0 160px;
    // width: 1600px;
    margin: 0 auto;

    .logo {
      width: 122px;
      height: 41px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .nav-menu {
      .nav-list {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0;
        gap: 54px;
        .nav-item {
          position: relative;
          font-size: 16px;
          color: #ffffff;
          cursor: pointer;
          transition: color 0.2s;
          &::after {
            content: "";
            display: block;
            position: absolute;
            left: 50%;
            bottom: -28px;
            width: 0;
            height: 1px;
            background: #fff;
            border-radius: 1px;
            transform: translateX(-50%);
            opacity: 0;
            transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s;
          }
          &.active::after {
            width: 98px;
            opacity: 1;
          }
        }
      }
    }
  }
}
@media (max-width: 1599px) {
  .nav-list {
    gap: 27px !important;
    .nav-item {
      font-size: 12px !important;
      &::after {
        bottom: -32px !important;
      }
      &.active::after {
        width: 56px !important;
      }
    }
  }
}

/* （1920px及以上） */
@media (min-width: 1920px) {
  .header-content {
    width: 1600px !important;
  }
}
</style>
